import React from 'react';

import {Trans, useTranslation} from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import graphic from '../../../resources/images/artist-wizard/step1.svg'
import Button from "../../common/inputs/Button";

const StepIntroduction = ({handleBack, handleNext}) => {
    const {t} = useTranslation();

    return (
        <Grid container spacing={3}  direction="row"
              justifyContent="center" >
            <Grid item xs={4} md={4}>
                <img src={graphic} alt='artist' width="100%"/>
            </Grid>
            <Grid item xs={12} md={8}>
                <Grid container spacing={3}  direction="column" justifyContent="center" >

                    <Grid item xs={12}>
                        <Typography variant="h5" color="textPrimary" component="h5">
                            {t('artist_wizard_step_1_title')}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                       <Trans i18nKey="artist_wizard_step_1_desc">
                           sample
                            <br/>
                            <strong>sample</strong>
                       </Trans>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justifyContent='center'>

                            <Button onClick={handleNext} variant="contained" color="primary">
                                {t('start_artist_wizard_btn')}
                            </Button>
                        </Grid>
                    </Grid>


                </Grid>
            </Grid>
        </Grid>
    );
};

export default StepIntroduction;